module.exports = {
    alpha: 'alpha',
    alphanumeric: 'alphanumeric',
    radiolist: 'radiolist',
    checkboxlist: 'checkboxlist',
    fileuploader: 'fileuploader',
    number: 'number',
    email: 'email',
    singleImage: 'singleImage',
    dropdown: 'dropdown',
}